<template>
  <div>
    <el-card class="mb-2" shadow="never">
      <div class="d-flex align-items-end">
        <div class="d-flex">
          <el-image
            :src="baseInfo.defaultImageUrl || '/image/static/img/nopic.jpg'"
            :preview-src-list="[
              baseInfo.defaultImageUrl || '/image/static/img/nopic.jpg',
            ]"
            style="width: 134px; height: 88px"
            fit="cover"
          >
            <div slot="error">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 120px; height: 80px"
              />
            </div>
          </el-image>
        </div>
        <div style="flex: 1;" class="ml-2">
          <h5 style="color: #101010;">
            {{
              baseInfo.fabricName ||
                $l('INDEX.detail_placeholder_addFabric') ||
                '新增面料信息'
            }}
          </h5>
          <h6 style="color: #303133;font-size: 14px;">
            {{
              baseInfo.fabricNameEn ||
                $l('INDEX.detail_placeholder_addFabric') ||
                '新增面料信息'
            }}
          </h6>
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <div style="height: 29px;line-height: 29px;overflow: hidden;">
                <span style="font-size: 14px; color: #606266">
                  No：{{
                    baseInfo.fabricNo ||
                      (isCopy
                        ? 'Copy'
                        : $l('INDEX.detail_placeholder_fabricNoAuto') ||
                          '面料编号自动生成')
                  }}
                </span>
                <el-divider direction="vertical" />
                <el-tag
                  size="mini"
                  :type="
                    baseInfo.fabricStatus === 'Y'
                      ? 'success'
                      : baseInfo.fabricStatus === 'N'
                      ? 'danger'
                      : ''
                  "
                >
                  {{ baseInfo.v_fabricStatus || 'New' }}
                </el-tag>
                <el-divider direction="vertical" v-if="baseInfo.fabricCode" />
                <span
                  style="font-size: 14px; color: #606266"
                  v-if="baseInfo.fabricCode"
                >
                  Modify：{{ baseInfo.modifyByName || '--' }} at
                  {{ baseInfo.modifyDate || '--' }}
                </span>
              </div>
            </div>
            <div class="switch-tabs_wrappers">
              <div class="switch-tabs">
                <div
                  v-for="item in switchTabs"
                  :key="item.value"
                  class="switch-tabs_items"
                  :class="{
                    active: item.value === activeName,
                    disabled: item.disabled,
                  }"
                  @click="!item.disabled ? (activeName = item.value) : () => {}"
                >
                  <span>{{ item.label }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <div>
      <el-card v-show="activeName == 'base'" shadow="never">
        <EditForm
          ref="editForm"
          :disabled="disabled"
          :fabricCode="fabricCode"
          :fabricSeriesCode="fabricSeriesCode"
          :isCopy="isCopy"
          :form="form"
          @loaded="loaded"
        />
        <div class="d-flex justify-content-end mt-3">
          <el-button
            v-if="!disabled"
            type="primary"
            size="small"
            @click="$refs.editForm.save()"
          >
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-card>
      <el-card v-if="activeName == 'image'" shadow="never">
        <FabricImage
          :disabled="baseInfo.fabricStatus === 'N'"
          :fabricCode="isCopy ? '' : fabricCode"
          @reload="$refs.editForm.reload()"
        />
      </el-card>
    </div>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import FabricImage from '../components/fabric-image'
export default {
  name: 'ecom-awsSample-fabric-detail',
  components: { EditForm, FabricImage },
  props: {
    form: { type: Object, default: () => {} },
    fabricInfoCode: { type: String, default: '' },
    fabricSeriesCode: { type: String, default: '' },
    isFabricCopy: { type: Boolean, default: false },
    fabricDisabled: { type: Boolean, default: false },
  },
  data() {
    return { baseInfo: {}, activeName: 'base', copied: false }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    isCopy() {
      return (this.pageType === 'copy' || this.isFabricCopy) && !this.copied
    },
    disabled() {
      return this.pageType === 'detail' || this.fabricDisabled
    },
    fabricCode() {
      return (
        this.params.fabricCode ||
        this.baseInfo.fabricCode ||
        this.fabricInfoCode
      )
    },
    switchTabs() {
      return [
        {
          label: this.$l('INDEX.switchTabs_label_base') || '基本信息',
          value: 'base',
        },
        {
          label: this.$l('INDEX.switchTabs_label_image') || '面料图片',
          value: 'image',
          disabled: this.isCopy || !this.fabricCode,
        },
      ]
    },
  },
  methods: {
    loaded(data) {
      this.baseInfo = data
      this.copied = data?.copied
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }
}
</style>
